module.exports = __webpack_public_path__ + "static/media/icon-temperature.4e07a002.svg";